
import React from 'react';

const AdFooter: React.FC = () => {
  return (
    <footer className="py-8 px-6 bg-gray-900 text-white/80 text-sm text-center animate-fade-in" style={{animationDelay: "100ms", animationFillMode: "forwards"}}>
      <div className="container mx-auto">
        <p className="mb-2">© {new Date().getFullYear()} Sparkwave AI. All rights reserved.</p>
        <p className="text-xs text-gray-400">
          Looking for more? <a href="https://sparkwave.ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary transition-colors underline">Visit the full site →</a>
        </p>
      </div>
    </footer>
  );
};

export default AdFooter;
